import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Signup_page1 from "../assets/img/Signup_page1.png";
import axios from "axios";
const SignupPage = () => {
  const [formData, setformData] = useState({
    name: "",
    email: "",
    contact_no: "",
  });
  const [selectedOption, setSelectedOption] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [errors, setErrors] = useState("");
  const [status, setStatus] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleChange = (e) => {
    setformData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleDropdownChange = (e) => {
    setSelectedOption(e.target.value);
    setInputValue(""); //If select option changes it clears previous text in the input
  };
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };
   const getPlaceholder = () => {
     switch (selectedOption) {
       case "Student":
         return "Institution Name";
       case "Administrator":
         return "Hospital/Institution Name";
       case "Research Associate":
         return "Institution Name";
       case "Doctor":
         return "Hospital/Institution Name";
       case "Others":
         return "Others/Profession/Institution Name";
       default:
         return "Description";
     }
   };
  const nameValidator = (firstName) => {
    const namePattern = /^[A-Za-z\s]+$/;
    return namePattern.test(firstName);
  };
  const emailValidator = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const contactNumberValidator = (contact_no) => {
    const contactNumberRegex = /^(0\d+-?\d+|\+91\d+|\+\d+|\d{10,})$/;
    return contactNumberRegex.test(contact_no);
  };
  const validateSignup = () => {
    const errorMsg = {};
    if (!formData.name.trim()) {
      errorMsg.name = "Name is required";
    } else if (!nameValidator(formData.name)) {
      errorMsg.name = "Name should contain only letters and spaces.";
    }
    if (!formData.email) {
      errorMsg.email = "Email is Required";
    } else if (!emailValidator(formData.email)) {
      errorMsg.email = "Invalid email Format";
    }
    if (formData.contact_no && !contactNumberValidator(formData.contact_no)) {
      errorMsg.contact_no = "Please enter valid Contact Number";
    }
    if (!selectedOption) {
      errorMsg.selectedOption = "Profession is required";
    }
    if (!inputValue) {
      errorMsg.inputValue = "Description is required";
    }
    setErrors(errorMsg);
    return Object.keys(errorMsg).length === 0;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      ...formData,
      occupation: selectedOption,
      description: inputValue,
    };
    if (!validateSignup()) return;
    setLoading(true);
    try {
      const userDetails = await axios.post("/user-signup", data, {
        withCredentials: false,
      }); //Signup API
      const signupResponse = userDetails.data;
      if (signupResponse.response_code === 200) {
        setStatus({
          success: true,
          response_code: signupResponse.response_code,
          message: signupResponse.message,
        });
      } else {
        const message =
          Array.isArray(signupResponse.error) && signupResponse.error.length > 0
            ? signupResponse.error[0]
            : signupResponse.message;
        throw new Error(message);
      }
    } catch (error) {
      const message = error.response?.data?.error?.[0] || error.message;

      setStatus({
        success: false,
        response_code: error.response?.status || 400,
        message,
      });
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="container-fluid px-0">
      <div className="row d-flex justify-content-center align-items-center g-0 signup-container">
        <div className="col-12 col-md-6 signup-image-col">
          <img
            src={Signup_page1}
            alt="Signup_page1"
            className="img-fluid"
          ></img>
        </div>
        <div className="col-12 col-md-6 signup-form-col">
          <div className="d-flex flex-column align-items-center w-100 signup-header">
            <h2 className="fs-4 mb-4 text-center">Sign up</h2>
            <p className="fs-5 fw-normal text-muted text-center mb-md-4">
              Welcome To Tamilnadu Cancer Registry-Let's Create Account
            </p>
          </div>
          <form className="signup-form" onSubmit={handleSubmit}>
            {/* Bootstrap Modal for Status Message */}
            {status.response_code && (
              <div
                className="modal fade show"
                style={{
                  display: "block",
                  backgroundColor: "rgba(0,0,0,0.5)",
                }}
                tabIndex="-1"
                role="dialog"
              >
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div
                      className={`modal-header ${
                        status.response_code === 200
                          ? "bg-primary text-white"
                          : "bg-primary text-white"
                      }`}
                    >
                      <h5 className="modal-title">Signup</h5>
                    </div>

                    <div className="modal-body">
                      <p className="text-center">{status?.message}</p>
                    </div>

                    <div className="modal-footer">
                      {status?.success ? (
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => navigate("/Login")}
                        >
                          Ok
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => setStatus("")}
                        >
                          Close
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div class=" position-relative signup-formfield ">
              <label for="exampleInputname1" className="form-label">
                Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className=" form-control"
                id="exampleInputname1"
                name="name"
                placeholder="Enter your name"
                onChange={handleChange}
              ></input>
              {errors.name && (
                <p className="text-danger small">{errors.name}</p>
              )}
            </div>
            <div class="position-relative signup-formfield ">
              <label for="exampleInputEmail1" class="form-label">
                Email <span className="text-danger">*</span>
              </label>

              <input
                type="email"
                id="exampleInputEmail1"
                name="email"
                className="form-control"
                placeholder="Enter your email"
                onChange={handleChange}
              ></input>
              {errors.email && (
                <p className="text-danger small">{errors.email}</p>
              )}
            </div>
            <div class="position-relative signup-formfield">
              <label for="exampleContactNumber1" class="form-label">
                Contact Number
              </label>
              <input
                id="exampleContactNumber1"
                type="tel"
                name="contact_no"
                className="form-control"
                placeholder="Enter your number"
                onChange={handleChange}
              ></input>
              {errors.contact_no && (
                <p className="text-danger small">{errors.contact_no}</p>
              )}
            </div>
            <div class="position-relative signup-formfield">
              <label for="exampleProfession1" class="form-label">
                Profession <span className="text-danger">*</span>
              </label>

              <select
                id="exampleProfession1"
                value={selectedOption}
                className="form-select"
                onChange={handleDropdownChange}
              >
                <option value="">Select Profession</option>
                <option value="Student">Student</option>
                <option value="Administrator">Administrator</option>
                <option value="Research Associate">Research Associate</option>
                <option value="Doctor">Doctor</option>
                <option value="Others">Others</option>
              </select>
              {errors.selectedOption && (
                <p className="text-danger small">{errors.selectedOption}</p>
              )}
              {selectedOption && (
                <div class=" position-relative signup-formfield ">
                  <input
                    type="text"
                    name="description"
                    value={inputValue}
                    className="form-control"
                    placeholder={getPlaceholder()}
                    onChange={handleInputChange}
                  />
                  {errors.inputValue && (
                    <p className="text-danger small">{errors.inputValue}</p>
                  )}
                </div>
              )}
            </div>
            <div className="d-flex justify-content-center gap-3 mb-4">
              <button type="submit" className="btn btn-primary  me-4 mb-3 px-4">
                {loading ? (
                  <div className="spinner-border text-light" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                ) : (
                  "Sign up"
                )}
              </button>
              <button
                type="button"
                className="btn shadow  me-4 mb-3 bg-white rounded-3 px-4"
                onClick={() => navigate("/Login")}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default SignupPage;
